import script from "./ConfluenceMacroDashboardMainSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfluenceMacroDashboardMainSettings.vue?vue&type=script&setup=true&lang=js"

import "./ConfluenceMacroDashboardMainSettings.vue?vue&type=style&index=0&id=611844b8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-611844b8"]])

export default __exports__